import type { HTMLAttributes, ReactNode } from "react";

export interface RowActionsProps extends HTMLAttributes<HTMLElement> {
  /** Tablo hücresi için "td", tablo dışı kullanım için "div" (varsayılan). */
  as?: "td" | "div";
  children?: ReactNode;
}

export function RowActions({
  as: Tag = "div",
  children,
  className,
  ...rest
}: RowActionsProps) {
  const classes = ["qr-row-actions"];
  if (className) classes.push(className);

  return (
    <Tag className={classes.join(" ")} {...rest}>
      {children}
    </Tag>
  );
}

export interface RowConfirmProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function RowConfirm({ children, className, ...rest }: RowConfirmProps) {
  const classes = ["qr-row-confirm"];
  if (className) classes.push(className);

  return (
    <span className={classes.join(" ")} {...rest}>
      {children}
    </span>
  );
}
